export const windowWidth = window.innerWidth;
export const windowHeight = window.innerHeight;


export function isInView(el: HTMLElement) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= windowHeight;
}

